{
  "a11y.dailyPnl": "Daily profit and loss",
  "a11y.dashboard": "Dashboard",
  "account.changePassword": "Change password",
  "account.changePhoto": "Change photo",
  "account.confirmPassword": "Confirm new password",
  "account.currentPassword": "Current password",
  "account.emailReverify": "Profile updated. We sent a verification link to your new email — confirm it to keep signing in.",
  "account.language": "Language",
  "account.languageHint": "Choose the language for the whole app.",
  "account.memberSince": "Member since {date}",
  "account.newPassword": "New password",
  "account.passwordChanged": "Password changed. Other devices have been signed out.",
  "account.passwordReused": "Your new password must be different from your current password.",
  "account.photoTooLarge": "That image is too large. Please choose one under 8 MB.",
  "account.photoUnsupported": "Please choose a PNG, JPG, WebP or GIF image.",
  "account.profile": "Profile",
  "account.profileSaved": "Profile updated.",
  "account.removePhoto": "Remove",
  "account.security": "Password",
  "account.subtitle": "Manage your profile and password.",
  "account.title": "Your account",
  "admin.activeSubs": "Active subscriptions",
  "admin.activity": "Recent activity",
  "admin.balance": "Balance",
  "admin.byCustomer": "Net by customer",
  "admin.capacity": "Capacity",
  "admin.compReason": "Granted from the Admin Panel",
  "admin.complimentary": "Complimentary",
  "admin.cpuLoad": "CPU load",
  "admin.customers": "Customers",
  "admin.dailyPnl": "Daily profit and loss",
  "admin.details": "Details",
  "admin.equityCurve": "Cumulative profit",
  "admin.fleet": "All customers",
  "admin.grantComp": "Grant free access",
  "admin.last14": "Last 14 days",
  "admin.lifetime": "All time",
  "admin.memory": "Memory",
  "admin.mrr": "Monthly revenue",
  "admin.netToday": "Net today",
  "admin.noActivity": "No trades yet.",
  "admin.noCustomers": "No customers yet.",
  "admin.overview": "Overview",
  "admin.payingStopped": "Paying but stopped",
  "admin.perBotMem": "Memory per bot",
  "admin.price": "Price",
  "admin.restart": "Restart",
  "admin.restartsPaused": "Restarts paused",
  "admin.revokeComp": "Revoke free access",
  "admin.running": "Running",
  "admin.runningUnpaid": "Running unpaid",
  "admin.search": "Search customers",
  "admin.since": "since",
  "admin.slotsUsed": "{used} of {max} bots",
  "admin.step": "Step",
  "admin.stopped": "Stopped",
  "admin.suspend": "Suspend",
  "admin.suspended": "Suspended",
  "admin.system": "Server health",
  "admin.title": "Admin",
  "admin.trades": "Trades",
  "admin.unreachable": "Not responding",
  "admin.unsuspend": "Unsuspend",
  "admin.uptime": "Uptime",
  "admin.winLoss": "Wins and losses",
  "admin.winRate": "Win rate",
  "auto.candle": "candle",
  "auto.candles": "candles",
  "auto.eligible": "Eligible",
  "auto.floors": "A pair needs a payout of {min}% or more to be chosen, and {exec}% or more at the moment the trade is placed.",
  "auto.notProvisioned": "Automatic Mode is not enabled on this bot.",
  "auto.off": "Off",
  "auto.on": "On",
  "auto.payout": "Payout",
  "auto.skipped": "Skipped",
  "auto.summaryOff": "Pair selection is off. The analysis below keeps running, and your signal list trades the pair it names.",
  "auto.summaryOn": "Analysing {total} pairs on the {window}-candle window. {eligible} eligible to trade right now.",
  "auto.summaryOnOne": "Analysing 1 pair on the {window}-candle window. {eligible} eligible to trade right now.",
  "auto.title": "Automatic Mode",
  "auto.trend": "Trend",
  "auto.trendNone": "no confirmed trend",
  "billing.activating": "Payment received! Activating your subscription and taking you to your dashboard…",
  "billing.active": "Your subscription is active.",
  "billing.badgeDue": "Past due",
  "billing.badgeFree": "Free",
  "billing.badgeOperator": "Operator",
  "billing.badgePro": "Pro",
  "billing.badgeTrial": "Trial",
  "billing.canceled": "Your subscription has ended. Subscribe again to resume.",
  "billing.checkoutCancelled": "Checkout cancelled. You can subscribe anytime.",
  "billing.checkoutSuccess": "Thank you! Your subscription is being activated — this can take a few seconds.",
  "billing.days": "days",
  "billing.feat1": "Automated trading on your Pocket Option account, 24/7",
  "billing.feat2": "Martingale strategy — configurable steps & multiplier",
  "billing.feat3": "Stop-loss & stop-win safety limits",
  "billing.feat4": "Real-time dashboard with full trade history",
  "billing.feat5": "Signal scheduling & OTC payout filtering",
  "billing.feat6": "Telegram alerts & session-health monitoring",
  "billing.fineprint": "Secure checkout powered by Stripe. Cancel anytime.",
  "billing.manageCta": "Manage subscription",
  "billing.month": "month",
  "billing.notConfigured": "Subscriptions aren't available just yet. Please check back soon.",
  "billing.opening": "Opening…",
  "billing.pastDue": "There's a problem with your payment. Please update your card to keep your subscription.",
  "billing.planName": "$mallX Subscription",
  "billing.renewsOn": "Renews on {date}.",
  "billing.startTrialCta": "Start free trial",
  "billing.subscribeBlurb": "Subscribe to keep your trading bot running.",
  "billing.subscribeCta": "Subscribe",
  "billing.subscribing": "Redirecting to checkout…",
  "billing.subtitle": "Manage your $mallX subscription.",
  "billing.tagline": "Everything you need to automate your Pocket Option trading.",
  "billing.title": "Subscription",
  "billing.trialActive": "Your free trial is active.",
  "billing.trialBanner": "Start with a {days}-day free trial — you won't be charged today.",
  "billing.trialChargeOn": "First charge on {date}.",
  "billing.trialDaysLeft": "{days} days left in your free trial",
  "billing.trialFineprint": "{days}-day free trial, then ${price}/month. Cancel anytime before it ends and pay nothing.",
  "billing.trialFlag": "{days} days free",
  "billing.trialLastDay": "Last day of your free trial",
  "billing.trialTagline": "Try everything free for {days} days — cancel anytime before it ends and pay nothing.",
  "bot.accountType": "Account to trade on",
  "bot.connectBlurb": "Enter the Pocket Option account your bot should trade on.",
  "bot.connectCta": "Connect account",
  "bot.connected": "Connected to {email}.",
  "bot.connectedBlurb": "Your bot is signed in and ready to trade.",
  "bot.connecting": "Connecting to Pocket Option…",
  "bot.connectingCta": "Connecting…",
  "bot.createBlurb": "Set up your own private trading bot. It runs on its own, using your Pocket Option account.",
  "bot.createCta": "Create my bot",
  "bot.creating": "Creating your bot…",
  "bot.demo": "Demo (practice money)",
  "bot.disconnectCta": "Disconnect account",
  "bot.disconnecting": "Disconnecting…",
  "bot.passwordHint": "Stored securely on your bot only, and never shown again.",
  "bot.poEmail": "Pocket Option email",
  "bot.poPassword": "Pocket Option password",
  "bot.real": "Real (live money)",
  "bot.securityNote": "Your password is stored only on your own bot and is never shared or displayed.",
  "bot.subtitle": "Connect your Pocket Option account so your bot can trade for you.",
  "bot.title": "Your trading bot",
  "bot.verificationTitle": "Pocket Option needs to verify this login",
  "bot.verifyBlurb": "Pocket Option wants to confirm you are a person. You can do it here yourself — it takes a few seconds.",
  "bot.verifyClickPrompt": "Below is your bot's own sign-in page. Tick the \"I'm not a robot\" box, then press Sign In. Your password is already filled in and is never shown here.",
  "bot.verifyClosed": "Verification closed. Your bot is starting again.",
  "bot.verifyCta": "Complete verification",
  "bot.verifyOpening": "Opening your bot's sign-in page…",
  "bot.verifyTimeLeft": "{m}:{s} left",
  "bot.verifyTimedOut": "This verification expired. You can start it again.",
  "bot.verifyTitle": "Complete the Pocket Option check",
  "bot.verifyVerified": "Verified. Your bot is connecting again — this page will update on its own.",
  "botset.accountMode": "Trading account",
  "botset.confirmDemo": "Switch back to the Demo account?",
  "botset.confirmReal": "Switch to your REAL account? Trades will use real money.",
  "botset.confirmResetDay": "Reset today’s counters?",
  "botset.confirmResetLadder": "Reset the Martingale ladder?",
  "botset.connection": "Pocket Option connection",
  "botset.controls": "Controls",
  "botset.realWarning": "Real money. Check your stop loss before switching.",
  "botset.resetDay": "Reset daily counters",
  "botset.resetDaySub": "Clears today profit, wins and losses",
  "botset.resetLadder": "Reset Martingale ladder",
  "botset.resetLadderSub": "Back to step 0 and clear any halt",
  "botset.switchPending": "A switch is already in progress.",
  "botset.switchPendingHint": "The bot is still finishing an earlier switch. You can send it again if it did not go through.",
  "botset.switchToDemo": "Switch to Demo",
  "botset.switchToReal": "Switch to Real",
  "botset.switched": "Now on the {mode} account.",
  "botset.switching": "Switching, this can take up to a minute…",
  "botset.title": "Bot settings",
  "brand.name": "$mallX",
  "brand.tagline": "Bot Time Is Money",
  "cel.autoclose": "This window will close automatically in",
  "cel.cta": "AWESOME — SEE YOU TOMORROW",
  "cel.seconds": "seconds…",
  "cel.stopWin": "Stop-Win",
  "cel.subtitle": "reached — profits secured for today.",
  "cel.titleAccent": "TARGET",
  "cel.titleAfter": "HIT",
  "cel.titleBefore": "DAILY",
  "cel.todaysProfit": "TODAY'S PROFIT",
  "common.back": "Back",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.confirm": "Confirm",
  "common.email": "Email",
  "common.genericError": "Something went wrong. Please try again.",
  "common.hidePassword": "Hide",
  "common.loading": "Loading…",
  "common.name": "Full name",
  "common.networkError": "Can't reach the server. Check your connection and try again.",
  "common.none": "None",
  "common.password": "Password",
  "common.reconnecting": "Reconnecting…",
  "common.refresh": "Refresh",
  "common.save": "Save changes",
  "common.saveChanges": "Save",
  "common.saving": "Saving…",
  "common.showPassword": "Show",
  "community.blurb": "Join the official $mallX channel and group on Telegram.",
  "community.channel": "Official channel",
  "community.channelSub": "Announcements and updates",
  "community.group": "Community group",
  "community.groupSub": "Chat with other $mallX traders",
  "community.title": "Community",
  "dash.acceptingSignals": "Accepting signals · ready to trade",
  "dash.account": "Account",
  "dash.balanceDemo": "Demo balance",
  "dash.balanceReal": "Account balance",
  "dash.connected": "Connected",
  "dash.cycleWL": "Cycle W · L",
  "dash.cycles": "Cycles",
  "dash.cyclesToday": "Cycles Today",
  "dash.demoMode": "Practice mode · no real money",
  "dash.equity": "Your profit over time",
  "dash.haltActive": "Safety halt active",
  "dash.halted": "Halted",
  "dash.haltedBlurb": "Stopped for today by a safety limit.",
  "dash.lastMgStep": "Last MG Step",
  "dash.losses": "Losses",
  "dash.manage": "Manage",
  "dash.netPnl": "Net P&L",
  "dash.nextStake": "Next stake",
  "dash.offline": "Offline",
  "dash.paused": "Paused",
  "dash.pausedBlurb": "Not trading. Press Start when you are ready.",
  "dash.quickStats": "Quick stats",
  "dash.realMode": "Live account · real money",
  "dash.running": "Running",
  "dash.start": "Start",
  "dash.step": "Martingale step",
  "dash.stop": "Stop",
  "dash.title": "Your bot",
  "dash.today": "Today",
  "dash.todayNote": "These are today's totals for the current day in the bot's configured local timezone — they reset at local midnight. No data is ever lost: your complete all-time record is always kept in History → All.",
  "dash.todayPnl": "Today P&L",
  "dash.tradesToday": "Trades today",
  "dash.winLoss": "Wins and losses",
  "dash.winRate": "Cycle Win Rate",
  "dash.wins": "Wins",
  "error.already_subscribed": "You already have a subscription. Use \"Manage subscription\" to update your card or plan.",
  "error.bot_not_runnable": "Your bot cannot trade right now.",
  "error.bot_timeout": "Your bot did not respond in time. If this was a trade it may still be running — do not resend it.",
  "error.bot_unreachable": "Your bot is not responding. It may be starting up.",
  "error.email_not_verified": "Please confirm your email address before signing in. Check your inbox for the verification link.",
  "error.email_taken": "An account with that email already exists.",
  "error.invalid_credentials": "Invalid email or password.",
  "error.invalid_current_password": "Current password is incorrect.",
  "error.invalid_payload": "Please check the form and try again.",
  "error.invalid_token": "This reset link is invalid or has expired.",
  "error.network": "Can't reach the server. Check your connection and try again.",
  "error.no_customer": "No billing account yet — subscribe first.",
  "error.no_tenant": "Create your bot first.",
  "error.not_configured": "Subscriptions aren't available just yet. Please check back soon.",
  "error.not_found": "Account not found.",
  "error.not_linked": "Connect your Pocket Option account first.",
  "error.password_reused": "Your new password must be different from your current password.",
  "error.rate_limited": "Too many attempts. Please try again in a few minutes.",
  "error.server_error": "Something went wrong on our end. Please try again.",
  "error.slow_down": "Please wait a moment before trying that again.",
  "error.subscription_required": "An active subscription is required.",
  "error.tenant_suspended": "This bot has been suspended. Please contact support.",
  "error.unauthorized": "Please sign in to continue.",
  "error.unsupported_expiry": "That expiry is not available on Pocket Option. Use 30s, 1m, 3m, 5m, 30m, 1h or 4h.",
  "error.unsupported_timeframe": "Some lines use a timeframe Pocket Option cannot place (M15). Nothing was queued; see the lines below.",
  "error.weak_password": "Password must be at least {min} characters.",
  "forgot.backToLogin": "Back to sign in",
  "forgot.cta": "Send reset link",
  "forgot.sent": "If an account exists for that email, a reset link is on its way. The link expires in 1 hour.",
  "forgot.subtitle": "Enter your email and we'll send you a reset link.",
  "forgot.title": "Reset your password",
  "forgot.working": "Sending…",
  "history.all": "All",
  "history.byLevel": "Results by Martingale level",
  "history.clear": "Clear history",
  "history.confirmClear": "Clear all trade history? Daily counters are not affected.",
  "history.empty": "No trades yet.",
  "history.net": "Net",
  "history.noMg": "No MG",
  "history.profit": "Profit",
  "history.stake": "stake ${amount}",
  "history.title": "History",
  "history.today": "Today",
  "history.trades": "trades",
  "history.week": "This week",
  "history.winRate": "win rate",
  "history.wins": "wins",
  "login.checkEmail": "Account created. Check your email for a verification link, then sign in.",
  "login.cta": "Sign in",
  "login.forgot": "Forgot your password?",
  "login.noAccount": "Don't have an account?",
  "login.resendVerification": "Resend verification email",
  "login.resending": "Sending…",
  "login.signUp": "Create one",
  "login.subtitle": "Sign in to your $mallX account.",
  "login.title": "Welcome back",
  "login.verificationResent": "If that account exists and isn't verified yet, a new verification email is on its way.",
  "login.working": "Signing in…",
  "nav.account": "Account",
  "nav.accountMenu": "Account menu",
  "nav.admin": "Admin",
  "nav.billing": "Billing",
  "nav.bot": "My bot",
  "nav.dashboard": "Dashboard",
  "nav.history": "History",
  "nav.language": "Language",
  "nav.settings": "Settings",
  "nav.signOut": "Sign out",
  "nav.strategy": "Strategy",
  "nav.trading": "Trading",
  "reason.pausedByUser": "Paused by user",
  "reason.unknown": "Stopped",
  "reset.confirmPassword": "Confirm new password",
  "reset.cta": "Update password",
  "reset.goToLogin": "Go to sign in",
  "reset.mismatch": "Those passwords don't match.",
  "reset.missingToken": "This reset link is incomplete or has expired. Please request a new one.",
  "reset.newPassword": "New password",
  "reset.requestNew": "Request a new link",
  "reset.subtitle": "Enter a new password for your account.",
  "reset.success": "Password updated. You can now sign in.",
  "reset.title": "Choose a new password",
  "reset.working": "Updating…",
  "signup.cta": "Create account",
  "signup.haveAccount": "Already have an account?",
  "signup.passwordHint": "At least {min} characters.",
  "signup.signIn": "Sign in",
  "signup.subtitle": "Start automating your Pocket Option trading.",
  "signup.title": "Create your account",
  "signup.working": "Creating your account…",
  "status.abandoned": "Abandoned",
  "status.cancelled": "Cancelled",
  "status.completed": "Done",
  "status.executing": "Running",
  "status.loss": "Loss",
  "status.pending": "Pending",
  "status.skipped": "Skipped",
  "status.tie": "Tie",
  "status.unknown": "Unknown",
  "status.win": "Win",
  "strategy.baseAmount": "Base amount",
  "strategy.enabled": "Enabled",
  "strategy.invalidFields": "Every field needs a number (0 or more). Nothing was saved.",
  "strategy.martingale": "Martingale",
  "strategy.maxSteps": "Maximum steps",
  "strategy.multiplier": "Multiplier",
  "strategy.payout": "Minimum payout percent",
  "strategy.rateLimit": "Trades per hour, 0 means unlimited",
  "strategy.safety": "Safety limits",
  "strategy.saved": "Saved.",
  "strategy.stopLoss": "Daily stop loss",
  "strategy.stopWin": "Daily profit target",
  "strategy.title": "Strategy",
  "strategy.zeroOff": "0 turns this limit off.",
  "trade.amount": "Amount",
  "trade.asset": "Asset",
  "trade.batchResult": "{live} queued to fire · {stale} already past today · {invalid} invalid",
  "trade.buy": "Buy",
  "trade.cancelOne": "Cancel",
  "trade.clearQueue": "Clear queue",
  "trade.confirmClearQueue": "Clear the signal queue? Pending signals will be cancelled.",
  "trade.direction": "Direction",
  "trade.executingNow": "executing now…",
  "trade.expiry": "Expiry in seconds",
  "trade.firingNow": "firing now…",
  "trade.inTime": "in {t}",
  "trade.lineN": "line {n}:",
  "trade.place": "Place trade",
  "trade.placeSignal": "Place a trade",
  "trade.placing": "Trade running, this takes about 70 seconds…",
  "trade.queueCounts": "{pending} pending · {done} done",
  "trade.queueEmpty": "No signals queued.",
  "trade.queueTitle": "Signal queue",
  "trade.rowEntry": "entry {time} local",
  "trade.sell": "Sell",
  "trade.skipPast": "skipped — that time had already passed today",
  "trade.title": "Trading",
  "trade.tzHint": "Times are read in your device's local clock ({tz}). The bot converts to UTC itself.",
  "trade.upload": "Add to queue",
  "trade.uploadHint": "One signal per line, for example EURUSD_OTC-CALL-M1/14:30",
  "trade.uploadTitle": "Add signals",
  "trade.useMartingale": "Use Martingale",
  "validation.email": "Enter a valid email address.",
  "validation.min": "Must be at least {min} characters.",
  "validation.required": "This field is required.",
  "verify.goToLogin": "Go to sign in",
  "verify.missingToken": "This verification link is incomplete or has expired. Sign in and request a new one.",
  "verify.success": "Email verified. You can now sign in.",
  "verify.title": "Verify your email",
  "verify.working": "Confirming your email…"
}
